/**
 * @generated SignedSource<<1f991370b37c3a4eb8851235053bf532>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AskFellowHooks_useAskFellowButton_note$data = {
  readonly id: string;
  readonly " $fragmentType": "AskFellowHooks_useAskFellowButton_note";
};
export type AskFellowHooks_useAskFellowButton_note$key = {
  readonly " $data"?: AskFellowHooks_useAskFellowButton_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"AskFellowHooks_useAskFellowButton_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AskFellowHooks_useAskFellowButton_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "1ed3e995421877ec8174134dc4d5a88b";

export default node;
